import {
  Modal,
} from '@/components/Modals';
import type {
  ModalProps,
} from '@/components/Modals';
import Text from '@/ui/components/Text';

import styles from './ConfirmationModal.module.css';

type ConfirmationModalProps = ModalProps & {
  loading?: boolean;
}

const ConfirmationModal = (props: ConfirmationModalProps) => {
  // ##########################################################################
  // PROPS
  // ##########################################################################

  const {
    title = 'Are you sure?',
    children,
    ...rest
  } = props;

  // ##########################################################################
  // RENDER
  // ##########################################################################

  return (
    <Modal
      {...rest}
      cancelText="Cancel"
      confirmText="Confirm"
      className={styles.confirmationModal}
      contentClassName={styles.content}
      allowScrolling
    >
      <div className={styles.title}>
        <Text
          kind="heading-4"
          color="neutral-600"
          weight="600"
        >
          {title}
        </Text>
      </div>

      {children}
    </Modal>
  );
};

export default ConfirmationModal;
